export class ContractFilterDateType {
  name: string;
  selected: boolean;
  display: boolean;

  constructor(name: string, selected: boolean = false, display = true) {
    this.name = name;
    this.selected = selected;
    this.display = display;
  }
}

export class ContractFilterStatusType {
  name: string;
  selected: boolean;
  display: boolean;

  constructor(name: string, selected: boolean = false, display = true) {
    this.name = name;
    this.selected = selected;
    this.display = display;
  }
}

export class HistoryFilter {
  month: ContractFilterDateType[];
  status: ContractFilterStatusType[];

  constructor(month: ContractFilterDateType[] = [], status: ContractFilterStatusType[] = []) {
    this.month = month;
    this.status = status;
  }
}
